<template>
  <form ref="form">
    <span style="display:none"> {{detail}} </span>
    <b-form-group>
      <b-row>
        <b-col sm="2"> <label for="SignalTmp"> Örnek Sinyal </label> </b-col>
        <b-col sm="5"> <b-form-input id="SignalTmp" v-model="signalTmp" placeholder="Örnek Sinyal" /></b-col>
        <b-col sm="5"><h4 id="signalTmp"> <span v-for="(st,i) in signalTmp" :key="i" >{{st}}</span> </h4></b-col>
      </b-row>
    </b-form-group>
      <div style="overflow-y: scroll; overflow-x: hidden; height: 420px; margin: 1rem;"> 
        <validation-observer ref="receiverFormat">
          <b-tabs justified content-class="mt-3" align="center">
            <b-tab title="Genel Ayarlar">
              <b-form-group>
                  <b-row>
                    <b-col sm="3"> <label> Format Kodu </label> </b-col>
                    <b-col sm="3"> 
                      <validation-provider name="Format Kodu" :rules="{ required: true}" v-slot="validationContext">
                          <b-form-input v-model="format" placeholder="Format Kodu" :state="getValidationState(validationContext)" />
                          <b-form-invalid-feedback id="live-feedback" style="display: block">
                              {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                    <b-col sm="2"> <label> Format Adı </label> </b-col>
                    <b-col sm="4">
                      <validation-provider name="Format Adı" :rules="{ required: true}" v-slot="validationContext">
                          <b-form-input  v-model="name" placeholder="Format Adı"  :state="getValidationState(validationContext)" />
                          <b-form-invalid-feedback id="live-feedback" style="display: block">
                              {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                  </b-row>
              </b-form-group>
              <b-form-group>
                  <b-row>
                    <b-col sm="3"> <label> Data Boyutu </label> </b-col>
                    <b-col sm="3"> 
                      <validation-provider name="Data Boyutu" :rules="{ required: true, numeric: true}" v-slot="validationContext">
                          <b-form-input  v-model="data_length" placeholder="Data Boyutu"  :state="getValidationState(validationContext)" />
                          <b-form-invalid-feedback id="live-feedback" style="display: block">
                              {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                    <b-col sm="6" style="display: flex; flex-direction: row; justify-content: center"> 
                        <b-form-checkbox name="auto_cid" v-model="auto_cid"> Otomatik CID Bölümleme </b-form-checkbox>
                        <b-form-checkbox name="combine_class_code" v-model="combine_class_code"> Class Kod Bitleştirme </b-form-checkbox>
                        <b-form-checkbox name="direct_process" v-model="direct_process">Direkt İşle </b-form-checkbox>
                    </b-col>
                  </b-row>
              </b-form-group>
              <b-form-group>
                  <b-row>
                    <b-col sm="3"> <label> En Küçük Değer </label> </b-col>
                    <b-col sm="3"> <b-form-input v-model="min" placeholder="En Küçük Değer" /></b-col>
                    <b-col sm="3"> <label> En Büyük Değer </label> </b-col>
                    <b-col sm="3"><b-form-input v-model="max" placeholder="En Büyük Değer" /></b-col>
                  </b-row>
              </b-form-group>
              <b-form-group>
                  <b-row>
                    <b-col sm="3"> <label> Açıklama</label> </b-col>
                    <b-col sm="9"> <b-textarea rows="5" v-model="explication" placeholder="Açıklama" /></b-col>
                  </b-row>
              </b-form-group>
            </b-tab>
            <b-tab title="Parçalama Ayarları">
                <b-form-group>
                  <b-row>
                    <b-col sm="6"> Format Başlangıç / Uzunluk </b-col>
                    <b-col sm="3"> 
                      <validation-provider name="Başlangıç" :rules="{ numeric: true}" v-slot="validationContext">
                          <b-form-input v-model="frmt_start" placeholder="Başlangıç" @focus="exampleColor(frmt_start, frmt_length)" @input="exampleColor(frmt_start, frmt_length)" :state="getValidationState(validationContext)" />
                          <b-form-invalid-feedback id="live-feedback" style="display: block">
                              {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                    <b-col sm="3">
                      <validation-provider name="Uzunluk" :rules="{ numeric: true}" v-slot="validationContext">
                          <b-form-input v-model="frmt_length" placeholder="Uzunluk" @focus="exampleColor(frmt_start, frmt_length)" @input="exampleColor(frmt_start, frmt_length)" :state="getValidationState(validationContext)" />
                          <b-form-invalid-feedback id="live-feedback" style="display: block">
                              {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                  </b-row>
                </b-form-group>
                <b-form-group>
                  <b-row>
                    <b-col sm="6"> Receiver No Başlangıç / Uzunluk </b-col>
                    <b-col sm="3"> 
                      <validation-provider name="Başlangıç" :rules="{ numeric: true}" v-slot="validationContext">
                          <b-form-input v-model="rcv_no_start" placeholder="Başlangıç" @focus="exampleColor(rcv_no_start, rcv_no_length)" @input="exampleColor(rcv_no_start, rcv_no_length)" :state="getValidationState(validationContext)" />
                          <b-form-invalid-feedback id="live-feedback" style="display: block">
                              {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                    <b-col sm="3">
                      <validation-provider name="Uzunluk" :rules="{ numeric: true}" v-slot="validationContext">
                          <b-form-input v-model="rcv_no_length" placeholder="Uzunluk" @focus="exampleColor(rcv_no_start, rcv_no_length)" @input="exampleColor(rcv_no_start, rcv_no_length)" :state="getValidationState(validationContext)" />
                          <b-form-invalid-feedback id="live-feedback" style="display: block">
                              {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                  </b-row>
                </b-form-group>
                <b-form-group>
                  <b-row>
                    <b-col sm="6"> Line Kart No Başlangıç / Uzunluk </b-col>
                    <b-col sm="3"> 
                      <validation-provider name="Başlangıç" :rules="{ numeric: true}" v-slot="validationContext">
                          <b-form-input v-model="lcr_start" placeholder="Başlangıç" @focus="exampleColor(lcr_start, lcr_length)" @input="exampleColor(lcr_start, lcr_length)" :state="getValidationState(validationContext)" />
                          <b-form-invalid-feedback id="live-feedback" style="display: block">
                              {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                    <b-col sm="3">
                      <validation-provider name="Uzunluk" :rules="{ numeric: true}" v-slot="validationContext">
                          <b-form-input v-model="lcr_length" placeholder="Uzunluk" @focus="exampleColor(lcr_start, lcr_length)" @input="exampleColor(lcr_start, lcr_length)" :state="getValidationState(validationContext)" />
                          <b-form-invalid-feedback id="live-feedback" style="display: block">
                              {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                  </b-row>
                </b-form-group>
                <b-form-group>
                  <b-row>
                    <b-col sm="6"> Abone Kodu Başlangıç / Uzunluk </b-col>
                    <b-col sm="3"> 
                      <validation-provider name="Başlangıç" :rules="{ numeric: true}" v-slot="validationContext">
                          <b-form-input v-model="acc_start" placeholder="Başlangıç" @focus="exampleColor(acc_start, acc_length)" @input="exampleColor(acc_start, acc_length)" :state="getValidationState(validationContext)" />
                          <b-form-invalid-feedback id="live-feedback" style="display: block">
                              {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                    <b-col sm="3">
                      <validation-provider name="Uzunluk" :rules="{ numeric: true}" v-slot="validationContext">
                          <b-form-input v-model="acc_length" placeholder="Uzunluk" @focus="exampleColor(acc_start, acc_length)" @input="exampleColor(acc_start, acc_length)" :state="getValidationState(validationContext)" />
                          <b-form-invalid-feedback id="live-feedback" style="display: block">
                              {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                  </b-row>
                </b-form-group>
                <b-form-group>
                  <b-row>
                    <b-col sm="6"> Olay Tipi (Event Qualifier) Başlangıç / Uzunluk </b-col>
                    <b-col sm="3"> 
                      <validation-provider name="Başlangıç" :rules="{ numeric: true}" v-slot="validationContext">
                          <b-form-input v-model="equ_start" placeholder="Başlangıç" @focus="exampleColor(equ_start, equ_length)" @input="exampleColor(equ_start, equ_length)" :state="getValidationState(validationContext)" />
                          <b-form-invalid-feedback id="live-feedback" style="display: block">
                              {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                    <b-col sm="3">
                      <validation-provider name="Uzunluk" :rules="{ numeric: true}" v-slot="validationContext">
                          <b-form-input v-model="equ_length" placeholder="Uzunluk" @focus="exampleColor(equ_start, equ_length)" @input="exampleColor(equ_start, equ_length)" :state="getValidationState(validationContext)" />
                          <b-form-invalid-feedback id="live-feedback" style="display: block">
                              {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                  </b-row>
                </b-form-group>
                <b-form-group>
                  <b-row>
                    <b-col sm="6"> Olay Kodu (Class & Event) Başlangıç / Uzunluk </b-col>
                    <b-col sm="3"> 
                      <validation-provider name="Başlangıç" :rules="{ numeric: true}" v-slot="validationContext">
                          <b-form-input v-model="ecd_start" placeholder="Başlangıç" @focus="exampleColor(ecd_start, ecd_length)" @input="exampleColor(ecd_start, ecd_length)"  :state="getValidationState(validationContext)" />
                          <b-form-invalid-feedback id="live-feedback" style="display: block">
                              {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                    <b-col sm="3">
                      <validation-provider name="Uzunluk" :rules="{ numeric: true}" v-slot="validationContext">
                          <b-form-input v-model="ecd_length" placeholder="Uzunluk" @focus="exampleColor(ecd_start, ecd_length)" @input="exampleColor(ecd_start, ecd_length)" :state="getValidationState(validationContext)" />
                          <b-form-invalid-feedback id="live-feedback" style="display: block">
                              {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                  </b-row>
                </b-form-group>
                <b-form-group>
                  <b-row>
                    <b-col sm="6"> Bölüm (Group Area) Başlangıç / Uzunluk </b-col>
                    <b-col sm="3"> 
                      <validation-provider name="Başlangıç" :rules="{ numeric: true}" v-slot="validationContext">
                          <b-form-input v-model="gno_start" placeholder="Başlangıç" @focus="exampleColor(gno_start, gno_length)" @input="exampleColor(gno_start, gno_length)" :state="getValidationState(validationContext)" />
                          <b-form-invalid-feedback id="live-feedback" style="display: block">
                              {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                    <b-col sm="3">
                      <validation-provider name="Uzunluk" :rules="{ numeric: true}" v-slot="validationContext">
                          <b-form-input v-model="gno_length" placeholder="Uzunluk" @focus="exampleColor(gno_start, gno_length)" @input="exampleColor(gno_start, gno_length)" :state="getValidationState(validationContext)" />
                          <b-form-invalid-feedback id="live-feedback" style="display: block">
                              {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                  </b-row>
                </b-form-group>
                <b-form-group>
                  <b-row>
                    <b-col sm="6"> Zone - Kullanıcı Başlangıç / Uzunluk </b-col>
                    <b-col sm="3"> 
                      <validation-provider name="Başlangıç" :rules="{ numeric: true}" v-slot="validationContext">
                          <b-form-input v-model="zno_start" placeholder="Başlangıç" @focus="exampleColor(zno_start, zno_length)" @input="exampleColor(zno_start, zno_length)" :state="getValidationState(validationContext)" />
                          <b-form-invalid-feedback id="live-feedback" style="display: block">
                              {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                    <b-col sm="3">
                      <validation-provider name="Uzunluk" :rules="{ numeric: true}" v-slot="validationContext">
                          <b-form-input v-model="zno_length" placeholder="Uzunluk" @focus="exampleColor(zno_start, zno_length)" @input="exampleColor(zno_start, zno_length)" :state="getValidationState(validationContext)" />
                          <b-form-invalid-feedback id="live-feedback" style="display: block">
                              {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                  </b-row>
                </b-form-group>
                <b-form-group>
                  <b-row>
                    <b-col sm="6"> Telefon No (CID) Başlangıç / Uzunluk </b-col>
                    <b-col sm="3">
                      <validation-provider name="Başlangıç" :rules="{ numeric: true}" v-slot="validationContext">
                          <b-form-input v-model="phn_start" placeholder="Başlangıç" @focus="exampleColor(phn_start, phn_length)" @input="exampleColor(phn_start, phn_length)" :state="getValidationState(validationContext)" />
                          <b-form-invalid-feedback id="live-feedback" style="display: block">
                              {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                    <b-col sm="3">
                      <validation-provider name="Uzunluk" :rules="{ numeric: true}" v-slot="validationContext">
                          <b-form-input v-model="phn_length" placeholder="Uzunluk" @focus="exampleColor(phn_start, phn_length)" @input="exampleColor(phn_start, phn_length)" :state="getValidationState(validationContext)" />
                          <b-form-invalid-feedback id="live-feedback" style="display: block">
                              {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                  </b-row>
                </b-form-group>
            </b-tab>
            <b-tab title="Tarih Ayarları">
                <b-form-group>
                  <b-row>
                    <b-col sm="6"> Saat Başlangıç / Uzunluk </b-col>
                    <b-col sm="3"> 
                      <validation-provider name="Başlangıç" :rules="{ numeric: true}" v-slot="validationContext">
                          <b-form-input v-model="hour_start" placeholder="Başlangıç" @focus="exampleColor(hour_start, hour_length)" @input="exampleColor(hour_start, hour_length)" :state="getValidationState(validationContext)" />
                          <b-form-invalid-feedback id="live-feedback" style="display: block">
                              {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                    <b-col sm="3">
                      <validation-provider name="Uzunluk" :rules="{ numeric: true}" v-slot="validationContext">
                          <b-form-input v-model="hour_length" placeholder="Uzunluk" @focus="exampleColor(hour_start, hour_length)" @input="exampleColor(hour_start, hour_length)" :state="getValidationState(validationContext)" />
                          <b-form-invalid-feedback id="live-feedback" style="display: block">
                              {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                  </b-row>
                </b-form-group>
                <b-form-group>
                  <b-row>
                    <b-col sm="6"> Dakika Başlangıç / Uzunluk </b-col>
                    <b-col sm="3"> 
                      <validation-provider name="Başlangıç" :rules="{ numeric: true}" v-slot="validationContext">
                          <b-form-input v-model="min_start" placeholder="Başlangıç" @focus="exampleColor(min_start, min_length)" @input="exampleColor(min_start, min_length)" :state="getValidationState(validationContext)" />
                          <b-form-invalid-feedback id="live-feedback" style="display: block">
                              {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                    <b-col sm="3">
                      <validation-provider name="Uzunluk" :rules="{ numeric: true}" v-slot="validationContext">
                          <b-form-input v-model="min_length" placeholder="Uzunluk" @focus="exampleColor(min_start, min_length)" @input="exampleColor(min_start, min_length)" :state="getValidationState(validationContext)" />
                          <b-form-invalid-feedback id="live-feedback" style="display: block">
                              {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                  </b-row>
                </b-form-group>
                <b-form-group>
                  <b-row>
                    <b-col sm="6"> Saniye Başlangıç / Uzunluk </b-col>
                    <b-col sm="3">
                      <validation-provider name="Başlangıç" :rules="{ numeric: true}" v-slot="validationContext">
                          <b-form-input v-model="sec_start" placeholder="Başlangıç" @focus="exampleColor(sec_start, sec_length)" @input="exampleColor(sec_start, sec_length)" :state="getValidationState(validationContext)" />
                          <b-form-invalid-feedback id="live-feedback" style="display: block">
                              {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                    <b-col sm="3">
                      <validation-provider name="Uzunluk" :rules="{ numeric: true}" v-slot="validationContext">
                          <b-form-input v-model="sec_length" placeholder="Uzunluk" @focus="exampleColor(sec_start, sec_length)" @input="exampleColor(sec_start, sec_length)" :state="getValidationState(validationContext)" />
                          <b-form-invalid-feedback id="live-feedback" style="display: block">
                              {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                  </b-row>
                </b-form-group>
                <b-form-group>
                  <b-row>
                    <b-col sm="6"> Gün Başlangıç / Uzunluk </b-col>
                    <b-col sm="3"> 
                      <validation-provider name="Başlangıç" :rules="{ numeric: true}" v-slot="validationContext">
                          <b-form-input v-model="day_start" placeholder="Başlangıç" @focus="exampleColor(day_start, day_length)" @input="exampleColor(day_start, day_length)" :state="getValidationState(validationContext)" />
                          <b-form-invalid-feedback id="live-feedback" style="display: block">
                              {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                    <b-col sm="3">
                      <validation-provider name="Uzunluk" :rules="{ numeric: true}" v-slot="validationContext">
                          <b-form-input v-model="day_length" placeholder="Uzunluk" @focus="exampleColor(day_start, day_length)" @input="exampleColor(day_start, day_length)" :state="getValidationState(validationContext)" />
                          <b-form-invalid-feedback id="live-feedback" style="display: block">
                              {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                  </b-row>
                </b-form-group>
                <b-form-group>
                  <b-row>
                    <b-col sm="6"> Ay Başlangıç / Uzunluk </b-col>
                    <b-col sm="3"> 
                      <validation-provider name="Başlangıç" :rules="{ numeric: true}" v-slot="validationContext">
                          <b-form-input v-model="month_start" placeholder="Başlangıç" @focus="exampleColor(month_start, month_length)" @input="exampleColor(month_start, month_length)" :state="getValidationState(validationContext)" />
                          <b-form-invalid-feedback id="live-feedback" style="display: block">
                              {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                    <b-col sm="3">
                      <validation-provider name="Uzunluk" :rules="{ numeric: true}" v-slot="validationContext">
                          <b-form-input v-model="month_length" placeholder="Uzunluk"  @focus="exampleColor(month_start, month_length)" @input="exampleColor(month_start, month_length)" :state="getValidationState(validationContext)" />
                          <b-form-invalid-feedback id="live-feedback" style="display: block">
                              {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                  </b-row>
                </b-form-group>
                <b-form-group>
                  <b-row>
                    <b-col sm="6"> Yıl Başlangıç / Uzunluk </b-col>
                    <b-col sm="3"> 
                      <validation-provider name="Başlangıç" :rules="{ numeric: true}" v-slot="validationContext">
                          <b-form-input v-model="year_start" placeholder="Başlangıç" @focus="exampleColor(year_start, year_length)" @input="exampleColor(year_start, year_length)" :state="getValidationState(validationContext)" />
                          <b-form-invalid-feedback id="live-feedback" style="display: block">
                              {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                    <b-col sm="3">
                      <validation-provider name="Uzunluk" :rules="{ numeric: true}" v-slot="validationContext">
                          <b-form-input v-model="year_length" placeholder="Uzunluk" @focus="exampleColor(year_start, year_length)" @input="exampleColor(year_start, year_length)" :state="getValidationState(validationContext)" />
                          <b-form-invalid-feedback id="live-feedback" style="display: block">
                              {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                      </validation-provider>
                    </b-col>
                  </b-row>
                </b-form-group>
            </b-tab>
            <b-tab title="Karakter Ayarları">
                <b-form-group>
                  <b-row>
                    <b-col sm="6"> Abone Kodu Başlangıç / Bitiş Karateri </b-col>
                    <b-col sm="3"> <b-form-input v-model="acc_start_char" placeholder="Başlangıç" @focus="exampleColor2(acc_start_char, acc_end_char)" @input="exampleColor2(acc_start_char, acc_end_char)"  /></b-col>
                    <b-col sm="3"><b-form-input v-model="acc_end_char" placeholder="Bitiş" @focus="exampleColor2(acc_start_char, acc_end_char)" @input="exampleColor2(acc_start_char, acc_end_char)"  /></b-col>
                  </b-row>
                </b-form-group>
                <b-form-group>
                  <b-row>
                    <b-col sm="6"> Telefon No (CID) Başlangıç / CID IP Karateri </b-col>
                    <b-col sm="3"> <b-form-input v-model="cid_start" placeholder="Başlangıç" @focus="exampleColor2(cid_start, cid_char)" @input="exampleColor2(cid_start, cid_char)"  /></b-col>
                    <b-col sm="3"><b-form-input v-model="cid_char" placeholder="CID IP" @focus="exampleColor2(cid_start, cid_char)" @input="exampleColor2(cid_start, cid_char)"  /></b-col>
                  </b-row>
                </b-form-group>
                <b-form-group>
                  <b-row>
                    <b-col sm="6"> Data Blok Başlangıç / Bitiş Karateri </b-col>
                    <b-col sm="3"> <b-form-input v-model="data_start_char" placeholder="Başlangıç" @focus="exampleColor2(data_start_char, data_end_char)" @input="exampleColor2(data_start_char, data_end_char)" /></b-col>
                    <b-col sm="3"><b-form-input v-model="data_end_char" placeholder="Bitiş" @focus="exampleColor2(data_start_char, data_end_char)" @input="exampleColor2(data_start_char, data_end_char)" /></b-col>
                  </b-row>
                </b-form-group>
                <b-form-group>
                  <b-row>
                    <b-col sm="6"> Gelen Olay / Çevrilen Olay Kodu </b-col>
                    <b-col sm="3"> <b-form-input v-model="evn_coming_code" placeholder="Gelen Olay Kodu" @focus="exampleColor2(0, 0)" @input="exampleColor2(0, 0)" /></b-col>
                    <b-col sm="3"><b-form-input v-model="evn_convert_code" placeholder="Dönüştürülen Olay Kodu" @focus="exampleColor2(0, 0)" @input="exampleColor2(0, 0)" /></b-col>
                  </b-row>
                </b-form-group>
                <b-form-group>
                  <b-row>
                    <b-col sm="6"> Gelen Düzelme / Çevrilen Düzelme Kodu  </b-col>
                    <b-col sm="3"> <b-form-input v-model="rest_coming_code" placeholder="Gelen Düzelme Kodu" @focus="exampleColor2(0, 0)" @input="exampleColor2(0, 0)" /></b-col>
                    <b-col sm="3"><b-form-input v-model="rest_convert_code" placeholder="Dönüştürülen Düzelme Kodu" @focus="exampleColor2(0, 0)" @input="exampleColor2(0, 0)" /></b-col>
                  </b-row>
                </b-form-group>
            </b-tab>
          </b-tabs>
        </validation-observer>
    </div>
  </form>
</template>

<script>
export default {
  name: "Protocols",
  data: function() {
    return {
      signalTmp: '5011 185858E60201000',
      format: "",
      name: "",
      frmt_start: 0,
      frmt_length: 0,
      rcv_no_start: 0,
      rcv_no_length: 0,
      lcr_start: 0,
      lcr_length: 0,
      acc_start: 0,
      acc_length: 0,
      equ_start: 0,
      equ_length: 0,
      ecd_start: 0,
      ecd_length: 0,
      gno_start: 0,
      gno_length: 0,
      zno_start: 0,
      zno_length: 0,
      hour_start: 0,
      hour_length: 0,
      min_start: 0,
      min_length: 0,
      sec_start: 0,
      sec_length: 0,
      day_start: 0,
      day_length: 0,
      month_start: 0,
      month_length: 0,
      year_start: 0,
      year_length: 0,
      acc_start_char: "",
      acc_end_char: "",
      data_start_char: "",
      data_end_char: "",
      phn_start: 0,
      phn_length: 0,
      evn_coming_code: "",
      evn_convert_code: "",
      rest_coming_code: "",
      rest_convert_code: "",
      combine_class_code: false,
      min: 0,
      max: 0,
      explication: "",
      cid_start: 0,
      cid_char: "",
      direct_process: false,
      data_length: 0,
      auto_cid: false 
    };
  },
  props: {
    data: Object,
    changeData: Function,
    save: Boolean,
    saveState: Function,
    modalName: String,
    modalEvent: Function
  },
  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    getDetail(data){
      this.format = data.format;
      this.name = data.name;
      this.frmt_length = data.frmt_length
      this.frmt_star = data.frmt_star
      this.rcv_no_start = data.rcv_no_start
      this.rcv_no_length = data.rcv_no_length
      this.lcr_start = data.lcr_start
      this.lcr_length = data.lcr_length
      this.acc_start = data.acc_start
      this.acc_length = data.acc_length
      this.equ_start = data.equ_start
      this.equ_length = data.equ_length
      this.ecd_start = data.ecd_start
      this.ecd_length = data.ecd_length
      this.gno_start = data.gno_start
      this.gno_length = data.gno_length
      this.zno_start = data.zno_start
      this.zno_length = data.zno_length
      this.hour_start = data.hour_start
      this.hour_length = data.hour_length
      this.min_start = data.min_start
      this.min_length = data.min_length
      this.sec_start = data.sec_start
      this.sec_length = data.sec_length
      this.day_start = data.day_start
      this.day_length = data.day_length
      this.month_start = data.month_start
      this.month_length = data.month_length
      this.year_start = data.year_start
      this.year_length = data.year_length
      this.acc_start_char = data.acc_start_char
      this.acc_end_char = data.acc_end_char
      this.data_start_char = data.data_start_char
      this.data_end_char = data.data_end_char
      this.phn_start = data.phn_start
      this.phn_start = data.phn_start
      this.evn_coming_code = data.evn_coming_code
      this.evn_convert_code = data.evn_convert_code
      this.rest_coming_code = data.rest_coming_code
      this.rest_convert_code = data.rest_convert_code
      this.combine_class_code = data.combine_class_code
      this.min = data.min
      this.max = data.max
      this.explication = data.explication
      this.cid_start = data.cid_start
      this.cid_char = data.cid_char
      this.direct_process = data.direct_process
      this.data_length = data.data_length
      this.auto_cid  = data.auto_cid
    },
    exampleColor(begin,length){
      this.signalTmp.split('').map((st,index) => {
        if(index >= begin-1 && index < parseInt(begin-1)+parseInt(length)){
          document.getElementById('signalTmp').getElementsByTagName('span')[index].style.color='red'
          document.getElementById('signalTmp').getElementsByTagName('span')[index].style.background='yellow'
        }else{
          document.getElementById('signalTmp').getElementsByTagName('span')[index].style.color='#000'
          document.getElementById('signalTmp').getElementsByTagName('span')[index].style.background='#fff'
        }
      })
    },
    exampleColor2(begin,end){
      let color = false
      this.signalTmp.split('').map((st,index) => {
        if(st == end)
          color = false
        if(color){
          document.getElementById('signalTmp').getElementsByTagName('span')[index].style.color='red'
          document.getElementById('signalTmp').getElementsByTagName('span')[index].style.background='yellow'
        }else{
          document.getElementById('signalTmp').getElementsByTagName('span')[index].style.color='#000'
          document.getElementById('signalTmp').getElementsByTagName('span')[index].style.background='#fff'
        }
        if(st == begin)
          color = true
      })
    },
  },
  computed: {
    detail(){
        if(this.data && this.data.item){
          this.getDetail(this.data.item)
          return this.data.item;
        }
    },
  },
  watch: {
    save: async function(data) {
      if (data) {
        this.$refs.receiverFormat.validate().then(async success => {
            if(success){
                let val = {
                format: this.format,
                name: this.name,
                frmt_start: parseInt(this.frmt_start),
                frmt_length: parseInt(this.frmt_length),
                rcv_no_start: parseInt(this.rcv_no_start),
                rcv_no_length: parseInt(this.rcv_no_length),
                lcr_start: parseInt(this.lcr_start),
                lcr_length: parseInt(this.lcr_length),
                acc_start: parseInt(this.acc_start),
                acc_length: parseInt(this.acc_length),
                equ_start: parseInt(this.equ_start),
                equ_length: parseInt(this.equ_length),
                ecd_start: parseInt(this.ecd_start),
                ecd_length: parseInt(this.ecd_length),
                gno_start: parseInt(this.gno_start),
                gno_length: parseInt(this.gno_length),
                zno_start: parseInt(this.zno_start),
                zno_length: parseInt(this.zno_length),
                hour_start: parseInt(this.hour_start),
                hour_length: parseInt(this.hour_length),
                min_start: parseInt(this.min_start),
                min_length: parseInt(this.min_length),
                sec_start: parseInt(this.sec_start),
                sec_length: parseInt(this.sec_length),
                day_start: parseInt(this.day_start),
                day_length: parseInt(this.day_length),
                month_start: parseInt(this.month_start),
                month_length: parseInt(this.month_length),
                year_start: parseInt(this.year_start),
                year_length: parseInt(this.year_length),
                acc_start_char: this.acc_start_char,
                acc_end_char: this.acc_end_char,
                data_start_char: this.data_start_char,
                data_end_char: this.data_end_char,
                phn_start: parseInt(this.phn_start),
                phn_length: parseInt(this.phn_length),
                evn_coming_code: this.evn_coming_code,
                evn_convert_code: this.evn_convert_code,
                rest_coming_code: this.rest_coming_code,
                rest_convert_code: this.rest_convert_code,
                combine_class_code: false,
                min: parseInt(this.min),
                max: parseInt(this.max),
                explication: this.explication,
                cid_start: parseInt(this.cid_start),
                cid_char: this.cid_char,
                direct_process: false,
                data_length: parseInt(this.data_length),
                auto_cid: false 
            }
            switch (this.modalName) {
              case "addFormat":
                val.id = this.data.id;
                await this.$store.dispatch("addFormat", val);
                break;
              case "editFormat":
                val.id = this.data.item.id;
                await this.$store.dispatch("editFormat", val);
                break;
            }
            if (this.$store.getters.getStatus.status == "Success") {
              this.$bvToast.toast('Receiver Formatı Ekleme / Düzenleme işlemi başarı ile gerçekleşti. Ayarlarınızın işleme geçmesi için lütfen GetSignal ve Processor servislerini yeniden başlatın', {
                  title: 'Başarılı',
                  variant: 'success',
                  solid: true
              })
               this.data.item ? this.$store.dispatch('listFormats', this.data.item.receiver_protocol_id) : this.$store.dispatch('listFormats', this.data.id)
            } else {
              this.$bvToast.toast('Receiver Formatı Ekleme / Düzenleme işlemi sırasında bir hata oluştu. Lütfen tüm alanları doğru bir şekilde doldurunuz', {
                  title: 'Dikkat',
                  variant: 'danger',
                  solid: true
              })
            }
          }
        })

        
      }
      this.saveState(false);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/General/Defination/modals/ReceiverFormat.vue